<template>
  <div class="managerNetworkSearchFilter">
    <div class="managerNetworkSearchFilter__firstSection">
      <div class="managerNetworkSearchFilter__firstSection__leftSection">
        <span
          class="btn-router"
          :class="{ 'router-link-active': params.isCorp }"
          @click="onChangeTab"
        >
          기업회원 검색
        </span>

        <span
          class="btn-router"
          :class="{ 'router-link-active': !params.isCorp }"
        >
          개인회원 검색
        </span>
      </div>
      <div class="managerNetworkSearchFilter__firstSection__rightSection">
        <div class="searchInput">
          <input
            type="text"
            placeholder="회원명을 입력하세요."
            v-model="params.name"
          />
        </div>
        <MainButton
          btnText="검색"
          width="74px"
          fontSize="18px"
          @click="handleChangeOption({ name: params.name })"
        />
        <MainButton
          btnText="초기화"
          width="92px"
          fontSize="18px"
          color="red"
          @click="handleChangeOption({ name: '' })"
        />
      </div>
    </div>

    <div class="managerNetworkSearchFilter__lastSection">
      <div style="flex:1">
        <div class="select-option" style="width: 100%">
          <b-form-select
            v-model="params.industryIdx"
            :options="age_friendly_industry"
            @change="onChangeMatchMaking"
          ></b-form-select>
          <p class="helper">*개인회원 관심분야 검색</p>
        </div>
      </div>
      <div class="border-column"></div>
      <div style="flex: 1;">
        <div class="select-option" style="width: 100%">
          <b-form-select
            v-model="params.activityIdx"
            :options="hope_activity"
            @change="onChangeHopeActivity"
          ></b-form-select>
          <p class="helper">*개인회원 관심활동 검색</p>
        </div>
      </div>

      <!-- <div class="border-column"></div>
      <div style="flex: 0.5;">
        <SelectOption
          :options="optionsSub"
          :handleChangeOption="handleChangeOption"
          width="100%"
        />
      </div> -->

      <div class="border-column"></div>

      <div style="flex: 1; display: flex; gap: 30px;">
        <!-- <SelectOption
          :options="optionsSub"
          :handleChangeOption="handleChangeOption"
          width="100%"
        /> -->
        <div>
          <button class="btn-solid">검색</button>
          <button class="btn-outlined" @click="resetOption">초기화</button>
        </div>
      </div>
    </div>

    <div style="display: flex; justify-content: center; padding-top: 24px;">
      <button class="btn-reset-filter" @click="resetAll">
        전체 검색 초기화
      </button>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import MainButton from "@/components/button/MainButton.vue";
import SelectOption from "@/components/formControl/SelectOption.vue";
import { ageFriendlyIndustry, hopeActivity } from "@/data/constances";

export default {
  name: "NetworkSearchFilter",
  components: { MainButton, SelectOption },
  props: ["params"],
  data() {
    const obj_age = [{ value: "", text: "옵션을 선택하세요" }],
      obj_hope_activity = [{ value: "", text: "옵션을 선택하세요" }];

    ageFriendlyIndustry.forEach((ele) => {
      obj_age.push({
        text: ele.name,
        value: ele.value,
      });
    });

    hopeActivity.forEach((ele) => {
      obj_hope_activity.push({
        text: ele.name,
        value: ele.value,
      });
    });
    return {
      age_friendly_industry: obj_age,
      hope_activity: obj_hope_activity,
      optionsSub: [{ text: "abc", value: 1 }],
    };
  },
  mounted() {},
  methods: {
    resetAll() {
      this.handleChangeOption({
        name: "",
        id: "",
        industryIdx: "",
        activityIdx: "",
        companyType: null
      });
    },
    resetOption() {
      this.handleChangeOption({
        id: "",
        industryIdx: "",
        activityIdx: "",
        companyType: null
      });
    },
    onChangeTab() {
      this.handleChangeOption({
        isCorp: true,
        name: "",
        id: "",
        industryIdx: "",
        activityIdx: "",
        companyType: null
      });
    },
    onChangeMatchMaking(val) {
      this.handleChangeOption({ industryIdx: val });
    },
    onChangeHopeActivity(val) {
      this.handleChangeOption({ activityIdx: val });
    },
    handleChangeOption(obj) {
      this.$emit("onchange", obj);
    },
  },
};
</script>

<style scoped lang="scss">
.btn-router {
  white-space: nowrap;
  width: 200px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fafafa;
  border-radius: 4px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 500;
  font-size: 2.2rem;
  line-height: 100%;
  letter-spacing: -0.05em;
  color: #a6a6a6;
  height: 46px;
}

.router-link-active {
  background: #26336a;
  color: #fff;
}

.border-column {
  border-left: 1px solid #d6d6d6;
  height: 34px;
}
</style>
